export const CATEGORY_CREATE = "categoryCreate";
export const CATEGORY_EDIT = "categoryEdit";
export const CATEGORY_GET = "categoryGet";
export const CATEGORIES_GET = "categoriesGet";
export const CATEGORY_SEARCH = "categorySearch";

export const CATEGORY_INACTIVE = 'categoryInactive'
export const CATEGORY_ACTIVE = 'categoryActive'
export const CATEGORY_DELETE = 'categoryDelete'
